import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  IconButton,
  Box,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const DynamicRowTable = ({ headers = [] }) => {
  const generateEmptyRow = () => {
    const emptyRow = {};
    headers.forEach((header) => {
      emptyRow[header.key] = "";
    });
    return emptyRow;
  };

  const [rows, setRows] = useState([generateEmptyRow()]);

  const handleAddRow = () => {
    // Add an empty row with the same structure as specified in the headers
    setRows([...rows, generateEmptyRow()]);
  };

  const handleDeleteRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };

  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const updatedRows = rows.map((row, i) =>
      i === index ? { ...row, [name]: value } : row
    );
    setRows(updatedRows);
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {headers.map((header) => (
              <TableCell key={header.key}>{header.header}</TableCell>
            ))}
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index}>
              {headers.map((header) => (
                <TableCell key={header.key}>
                  <TextField
                    type={header.type}
                    name={header.key}
                    size="small"
                    value={row[header.key]}
                    onChange={(event) => handleInputChange(index, event)}
                    variant="outlined"
                    fullWidth
                  />
                </TableCell>
              ))}
              <TableCell>
                <IconButton
                  onClick={() => handleDeleteRow(index)}
                  disabled={rows.length === 1}
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Box display={"flex"} justifyContent={"end"}>
        <Button
          onClick={handleAddRow}
          variant="outlined"
          color="primary"
          size="small"
          style={{ marginTop: "10px" }}
        >
          Add Row
        </Button>
      </Box>
    </TableContainer>
  );
};

export default DynamicRowTable;
